import { ToggleGroup, ToggleGroupItem } from 'app/javascript/components/ui/toggle-group';

interface StoreSizePickerProps {
  sizes: string[];
  value: string | null;
  onChange: (size: string | null) => void;
}

// Single-select size chooser on the product detail page. The chosen size is
// carried into the WhatsApp message, so selection gates the buy action above.
export default function StoreSizePicker({ sizes, value, onChange }: StoreSizePickerProps) {
  if (sizes.length === 0) return null;

  return (
    <div>
      <h2 className="mb-3 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Tamanho</h2>

      <ToggleGroup
        type="single"
        value={value ?? undefined}
        onValueChange={(next) => onChange(next || null)}
        className="flex-wrap justify-start gap-2"
      >
        {sizes.map((size) => (
          <ToggleGroupItem
            key={size}
            value={size}
            aria-label={`Tamanho ${size}`}
            className="min-h-11 min-w-12 rounded-md border border-slate-700/60 bg-slate-900 px-4 text-sm font-semibold uppercase tracking-wide text-slate-300 shadow-none hover:border-slate-600 hover:bg-slate-800/70 hover:text-foreground data-[state=on]:border-yellow-400/50 data-[state=on]:bg-yellow-400/10 data-[state=on]:text-yellow-400 data-[state=on]:shadow-none"
          >
            {size}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
}
